import React, { PureComponent } from 'react';
import { ButtonAnchor } from '../../../components/Button';
import { Column, Row } from '../../../components/Grid';
import { HtmlContent } from '../../../components/layout/HtmlContent';
import {
  FontIconHeadline,
  NewsletterSection,
  NewsletterSubline,
  iframeResize
} from '../../../components/Newsletter';
import { selectMenu } from '../../../provider/Typo3Provider/selectors';
import Typo3Label from '../../../provider/Typo3Provider/Typo3Label';
import {
  withTypo3,
  WithTypo3Props
} from '../../../provider/Typo3Provider/withTypo3';

interface NewsletterContainerProps {}

class NewsletterContainer extends PureComponent<
  NewsletterContainerProps & WithTypo3Props
> {
  public render() {
    const {
      typo3: { translateTypo3 }
    } = this.props;
    const [linkData = null] = selectMenu(this.props.typo3, 'newsletter');
    
    return (
      <>
        {linkData && linkData.link && <Row noGap bg="grayLight">
          <Column>
            <NewsletterSection className="hide-for-print">
              <Row noGap>
                <Column large={9} medium={12} small={12} alignSelf="center">
                  <Row>
                    <Column>
                      <FontIconHeadline icon="sendMail">
                        <HtmlContent
                          htmlString={translateTypo3('newsletter.action.headline')}
                        />
                      </FontIconHeadline>
                    </Column>
                    <Column>
                      <NewsletterSubline>
                        <Typo3Label label="newsletter.action.subline"/>
                      </NewsletterSubline>
                    </Column>
                  </Row>
                </Column>
                {(
                  <Column large={3} medium={12} small={12} alignSelf="center">
                    {/* TODO: Link:to */}
                    <ButtonAnchor href={linkData.link} secondary large>
                      <Typo3Label label="newsletter.action.button"/>
                    </ButtonAnchor>
                  </Column>
                )}
              </Row>
            </NewsletterSection>
          </Column>
          {iframeResize()}
        </Row>}
      </>
    );
  }
}

export default withTypo3(NewsletterContainer);
